export default ({data}) => {
  return `Posts tagged with "${data.tag}"`
}
